import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-0" }

import PopoverRoot from '@/components/modals/PopoverRoot.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import { useEmbeddedScrollLock } from '@/composables/useEmbeddedScrollLock';
import { useEmbeddedHostResize } from '@/composables/useEmbeddedHostResize';
import { useEmbeddedEnlargedImagePosition } from '@/composables/useEmbeddedEnlargedImagePosition';
import getEmbeddedInModule from '@/helpers/getEmbeddedInModule';
import InternalModules from '@/models/InternalModules';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useEmbeddedScrollLock();
// Why: SIU embeds the app in a fixed-height iframe without resize logic, so we
// report our content height and let the host grow the iframe — avoiding a second
// scrollbar inside the claim detail. No-op outside SIU (see composable).
useEmbeddedHostResize();
useEmbeddedEnlargedImagePosition();

// Why: tag the app root so the SIU-only layout overrides apply to EVERY view
// (claim detail, error, session-expired). The `min-height: 100vh` on
// `.view-container` is viewport-relative; inside the SIU iframe that couples the
// content height to the iframe height, and with useEmbeddedHostResize sizing the
// iframe to the content it runs away (each resize grows the viewport, which grows
// the content). Neutralising the floor app-wide keeps content at its natural
// height so the iframe converges.
const isEmbeddedInSiu = getEmbeddedInModule() === InternalModules.Siu;

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["screening-app", { 'embedded-siu': isEmbeddedInSiu }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PopoverRoot),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(AppLayout, { "data-test-id": "app-layout" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    ])
  ], 2))
}
}

})